import cx from "classnames";
import React, { useState } from "react";

import { BasicButton, ButtonType, Icon, IconSize } from "@gaming/xds-react-js";
import { Delete } from "@gaming/xds-react-js-icons";

import { useProgramBackgroundColorPicker } from "../../helpers/useProgramColorPicker";
import { useString, useStrings } from "../../localization/localizationHelpers";
import { Modal } from "../Modal/Modal";
import * as styles from "./DeleteButton.module.css";

type DeleteButtonProps = Readonly<{
  ariaLabel?: string;
  onClick: () => void;
}>;

export const DeleteButton = ({ onClick, ariaLabel }: DeleteButtonProps) => {
  const [confirmAction, conceptDeletionConfirmationText, confirm, deleteGameConcept, cancel] =
    useStrings(
      "confirmAction",
      "conceptDeletionConfirmationText",
      "confirm",
      "deleteGameConcept",
      "cancel"
    );
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const backgroundColorStyle = useProgramBackgroundColorPicker();

  const handleOpenConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };
  return (
    <>
      <BasicButton
        as={"button"}
        className={styles.deleteButton}
        onClick={handleOpenConfirmModal}
        onKeyDown={e => e.key === "Enter" && onClick?.()}
        tabIndex={0}
        role="link"
        textDecorationUnderline={true}
        aria-label={ariaLabel || deleteGameConcept}
      >
        <Icon
          aria-hidden={true}
          icon={Delete}
          className={styles.deleteButtonColor}
          iconSize={IconSize.Custom}
        />
      </BasicButton>
      <Modal isOpen={isConfirmModalOpen} onClose={handleCloseConfirmModal}>
        <div className={styles.modalHeader}>
          <h2 id="modal-title" className={styles.modalTitle}>
            {confirmAction}
          </h2>
        </div>
        <div id="modal-content" className={styles.modalBody}>
          {conceptDeletionConfirmationText}
        </div>
        <div className={styles.modalActions}>
          <BasicButton
            as={"button"}
            className={styles.cancelButton}
            onClick={handleCloseConfirmModal}
            type="button"
            buttonType={ButtonType.Secondary}
          >
            {cancel}
          </BasicButton>
          <BasicButton
            as={"button"}
            className={cx(styles.actionButton, backgroundColorStyle)}
            onClick={onClick}
            type="button"
            buttonType={ButtonType.Brand}
          >
            {confirm}
          </BasicButton>
        </div>
      </Modal>
    </>
  );
};

export const DeletePitchButton = ({ onClick }: DeleteButtonProps) => {
  const deletePitch = useString("deletePitch");
  return <DeleteButton onClick={onClick} ariaLabel={deletePitch} />;
};
